import { useQuery } from 'react-query';

import { Chronology } from '../types/backend-dto-types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterChronologies = ({ matterId }: { matterId: string | null }) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Chronology[]>(
    [QueryEntity.MatterChronologies, { matterId }],
    async () => {
      return fetch(`${APIBaseChronos}/api/matters/${matterId}/chronologies`, fetchConfigGET).then((res) => {
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, enabled: !!matterId },
  );
};
